import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

const getFilters = (state: RootState) => state.filters;
const getPartnerCategories = (state: RootState) => state.filters.partnerCategories;
const getSelectedPartnerCategories = (state: RootState) => state.filters.selectedPartnerCategories;
const getDistanceRadiusInKm = (state: RootState) => state.filters.distanceRadiusInKm;
const getSuggestedInput = (state: RootState) => state.filters.suggestedInput;
// const getDefaultCenter = (state: RootState) => state.filters.defaultCenter

export const filtersSelector = createSelector(getFilters, (filters) => filters);

export const partnerCategoriesSelector = createSelector(getPartnerCategories, (categories) => categories);

export const selectedPartnerCategoriesSelector = createSelector(getSelectedPartnerCategories, (categories) => categories);

export const distanceRadiusInKmSelector = createSelector(getDistanceRadiusInKm, (radiusInKm) => radiusInKm);

export const suggestedInputSelector = createSelector(getSuggestedInput, (input) => input);
